import React, { useEffect } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { MultiChoiceAnswerItem } from '../../../private/LearnEngineComponents/MultiChoiceAnswerItem/MultiChoiceAnswerItem';
import { ISlAnswerProps } from '../../globalInterfaces/learnEngineInterfaces';

import s from './SlMultiChoiceAnswer.scss';
import { AnswerOptionStatus, IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { i18n } from '../../../../symphony';

export function SlMultiChoiceAnswer({
	options,
	onChange,
	isValid,
}: ISlAnswerProps): JSX.Element {
	useStyles(s);
	useEffect(() => {
		if (onChange) {
			onChange(
				options.map((o) => ({
					...o,
					status: AnswerOptionStatus.Initial,
				})),
			);
		}
	}, []);

	const onOptionSelect = (selectedOptionId: number) => {
		const changedOptions: IAnswerOption[] = options.map(
			(option: IAnswerOption) => {
				if (option.id === selectedOptionId) {
					return {
						...option,
						status:
                            option.status === AnswerOptionStatus.Selected ? AnswerOptionStatus.Initial : AnswerOptionStatus.Selected,
					};
				}
				return option;
			},
		);
		isValid(
			changedOptions.some(
				(opt) => opt.status === AnswerOptionStatus.Selected,
			),
		);
		onChange(changedOptions);
	};

	return (
		<div
			className="sl-multi-choice-answer"
			sl-test-data="cmpMultiChoiceAnswer"
		>
			<div className="sl-multi-choice-answer__title">
				{i18n.t('web-le.quiz-incorrect-few-options')}
			</div>
			{options.map((option) => (
				<MultiChoiceAnswerItem
					key={option.id}
					option={option}
					onSelectOption={() => onOptionSelect(option.id)}
				/>
			))}
		</div>
	);
}
